// extracted by mini-css-extract-plugin
export default {"card":"C6-z"};